import Vue from 'vue';
import VueRouter from 'vue-router';
import Overview from '@/views/Overview.vue';
import Episode from '@/views/Episode.vue';
import About from '@/views/About.vue';
import Impressum from '@/views/Impressum.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        component: Overview,
        name: 'Overview'
    },
    {
        path: '/episode/:id',
        component: Episode,
        name: 'Episode',
    },
    {
        path: '/about',
        component: About,
        name: 'About'
    },
    {
        path: '/impressum',
        component: Impressum,
        name: 'Impressum'
    },
];

const router = new VueRouter({
    routes,
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        const appContainer = document.getElementById("app")
        appContainer.scrollTo(0, 0);
    },

});

export default router;